import { styled } from 'baseui'

export const Body = styled('div', ({ $theme }) => ({
  lineHeight: 1.5,
  overflowWrap: 'anywhere',
  ':first-child': { marginTop: 0 },
  p: { marginTop: 0, marginBottom: '0.5rem' },
  'p:last-child': { marginBottom: 0 },
  'ul, ol': { marginTop: '0.25rem', marginBottom: '0.5rem', paddingLeft: '1.25rem' },
  li: { marginBottom: '0.125rem' },
  a: { color: $theme.colors.linkBlue, textDecoration: 'underline' },
  img: { maxWidth: '100%', height: 'auto' },
  'h1, h2, h3, h4': { color: $theme.colors.primary, marginTop: '0.75rem', marginBottom: '0.25rem' },
  table: { borderCollapse: 'collapse', maxWidth: '100%' },
  'td, th': {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: $theme.colors.borderLight,
    padding: '0.25rem 0.5rem',
  },
}))
